import { render, staticRenderFns } from "./FormCompanyContent.vue?vue&type=template&id=e9b60afa&"
import script from "./FormCompanyContent.vue?vue&type=script&lang=js&"
export * from "./FormCompanyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports